import React from "react";
import Chips from "../../Chips";
import Tooltip from "../../Tooltip";
import "./index.scss";
import { IGameTableType } from "@/types/GlobalTypes";

export default class M11 extends React.PureComponent<IGameTableType> {
	render() {
		const { langdata } = this.props;

		const win = this.props.win || "";
		const wins = win.split(",");
		const pcodeProp = {pcode: this.props.pcode};

		const winC = {};
		wins.forEach((x) => { winC[x] = (winC[x] || 0) + 1; });
		
		const commonChipProps = {
			mobile: this.props.mobile,
			chipBase: this.props.chipBase,
			bets: this.props.bets,
			betOutOfBounds: this.props.betOutOfBounds
		};

		const commonTooltipProps = {
			langStr: langdata.language_code
		};

		return (
			this.props.portrait ?
			<div className="sl-table m11-portrait">
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["3"] > 0 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "3",
						group: "jackpot",
						...pcodeProp
					}}
						//bet="3" pcode={this.props.pcode} group="jackpot"

						onClick={this.props.insertBet}>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="bet-type">1:15</div>
						<Chips {...commonChipProps} betKey="3+jackpot" />
					</div>
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["3"] > 1 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "3,3",
						group: "jackpot",
						...pcodeProp
					}}
						//bet="3,3" pcode={this.props.pcode} group="jackpot"
						
						onClick={this.props.insertBet}>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="bet-type">1:225</div>
						<Chips {...commonChipProps} betKey="3,3+jackpot" />
					</div>
				</div>
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["1"] > 1 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "1,1",
						group: "n",
						...pcodeProp
					}}
						// bet="1,1" pcode={this.props.pcode} group="n"

						onClick={this.props.insertBet}>
						<div className="sl-red-darken square"></div>
						<div className="sl-red-darken square"></div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="1,1+n" />
					</div>
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["2"] > 1 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "2,2",
						group: "n",
						...pcodeProp
					}}
						// bet="2,2" pcode={this.props.pcode} group="n"
						onClick={this.props.insertBet}>
						<div className="sl-white square"></div>
						<div className="sl-white square"></div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="2,2+n" />
					</div>
				</div>
				<div className="row">
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["1"] === 3 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "1,1,1",
						group: "c",
						...pcodeProp
					}}
						//bet="1,1,1" pcode={this.props.pcode} group="c"

						onClick={this.props.insertBet}>
						<div className="sl-red-darken square"></div>
						<div className="sl-red-darken square"></div>
						<div className="sl-red-darken square"></div>
						<div className="bet-type">1:7</div>
						<Chips {...commonChipProps} betKey="1,1,1+c" />
					</div>
					<div className={"sl-bet col-xs-6 sl-green-old " + (winC["2"] === 3 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "2,2,2",
						group: "c",
						...pcodeProp
					}}
						// bet="2,2,2" pcode={this.props.pcode} group="c"
						onClick={this.props.insertBet}>
						<div className="sl-white square"></div>
						<div className="sl-white square"></div>
						<div className="sl-white square"></div>
						<div className="bet-type">1:7</div>
						<Chips {...commonChipProps} betKey="2,2,2+c" />
					</div>
				</div>

			</div>
			
		: <div className="sl-table m11-table">
				<div className="sides">
					<div className={"sl-bet sl-green-old" + (winC["3"] > 0 ? " sl-yellow-alternating" : "")}

					{...{
						bet: "3",
						group: "jackpot",
						...pcodeProp
					}}
						// group="jackpot" bet="3" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="bet-type">1:15</div>
						<Chips {...commonChipProps} betKey="3+jackpot" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["3+jackpot"]} />
					</div>
					<div className={"sl-bet sl-green-old" + (winC["1"] > 1 ? " sl-yellow-alternating" : "")}

					{...{
						bet: "1,1",
						group: "n",
						...pcodeProp
					}}
						// group="n" bet="1,1" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="square sl-red"></div>
						<div className="square sl-red"></div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="1,1+n" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["1,1+n"]} />
					</div>
					<div className={"sl-bet sl-green-old" + (winC["1"] === 3 ? " sl-yellow-alternating" : "")}

					{...{
						bet: "1,1,1",
						group: "c",
						...pcodeProp
					}}
						// group="c" bet="1,1,1" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="square sl-red"></div>
						<div className="square sl-red"></div>
						<div className="square sl-red"></div>
						<div className="bet-type">1:7</div>
						<Chips {...commonChipProps} betKey="1,1,1+c" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["1,1,1+c"]} />
					</div>
				</div>
				<div className="sides">
					<div className={"sl-bet sl-green-old" + (winC["3"] > 1 ? " sl-yellow-alternating" : "")}
					{...{
						bet: "3,3",
						group: "jackpot",
						...pcodeProp
					}}
						// group="jackpot" bet="3,3" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="sl-yellow square jp-btn">JP</div>
						<div className="bet-type">1:225</div>
						<Chips {...commonChipProps} betKey="3,3+jackpot" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["3,3+jackpot"]} />
					</div>
					<div className={"sl-bet sl-green-old" + (winC["2"] > 1 ? " sl-yellow-alternating" : "")}

					{...{
						bet: "2,2",
						group: "n",
						...pcodeProp
					}}
						// group="n" bet="2,2" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="square sl-white"></div>
						<div className="square sl-white"></div>
						<div className="bet-type">1:1</div>
						<Chips {...commonChipProps} betKey="2,2+n" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["2,2+n"]} />
					</div>
					<div className={"sl-bet sl-green-old" + (winC["2"] === 3 ? " sl-yellow-alternating" : "")}

					{...{
						bet: "2,2,2",
						group: "c",
						...pcodeProp
					}}
						// group="c" bet="2,2,2" pcode={this.props.pcode}

						onClick={this.props.insertBet}>
						<div className="square sl-white"></div>
						<div className="square sl-white"></div>
						<div className="square sl-white"></div>
						<div className="bet-type">1:7</div>
						<Chips {...commonChipProps} betKey="2,2,2+c" />
						<Tooltip {...commonTooltipProps} bet={this.props.bets["2,2,2+c"]} />
					</div>
				</div>
			</div>
		);
	}
}
